module.exports = __webpack_public_path__ + "static/rea-d431f678b6914d52adb0b156f581f78c.jpg";